export class ActivityType {
	code: string;
	name: string;
	description: string;
	hasActivityEntity: boolean;
	version: string;
}
